var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDesktopHangout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 12,
  viewBox: "0 0 11 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.128 9.559C4.2 9.6 4.2 12 4.2 12s2.532-2.216 3.266-2.597C9.094 8.56 10.2 6.903 10.2 5c0-.232.26.237-.086-1.125C9.65 2.05 7.348 0 5 0c-.391 0-1.468.041-1.828.12C.888.62 0 2.615 0 5c0 2.543 2.574 4.242 4.128 4.559"
})));
export default SvgGoogleDesktopHangout;